import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { GET_EVENT_QUERY_KEY } from '../../event-management/hooks/useGetEvent';
import { GET_EVENT_WAITLIST_QUERY_KEY } from './useGetEventWaitlist';

/**
 * Approve a waitlisted player (MYS-62). On a free event this enrols them; on a
 * paid event it opens a payment window (the player must pay to confirm).
 */
export const usePromoteFromWaitlist = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ eventId, userId }: { eventId: number; userId: string }) =>
            apiClient.fetchApi<unknown, {}>({
                method: 'POST',
                endpoint: `events/${eventId}/waitlist/promote/${userId}`,
            }),
        onSuccess: (_data, { eventId }) => {
            toast({
                title: translate('event.waitlist.approve_success'),
                status: 'success',
                duration: 4000,
                isClosable: true,
            });
            queryClient.invalidateQueries({ queryKey: GET_EVENT_WAITLIST_QUERY_KEY(eventId) });
            queryClient.invalidateQueries({ queryKey: GET_EVENT_QUERY_KEY(eventId) });
        },
        onError: (error: any) => {
            toast({
                title: translate('event.waitlist.approve_error'),
                description: error?.message,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
